import axios from "axios";

const emptyObj = {};

const apiDataCallback = (res) => res.data;

const getInstance = ({ baseURL, timeout = 30000, headers = {} }) => {
  const instance = axios.create({
    baseURL,
    timeout,
    headers,
  });

  return {
    get: (url, params = emptyObj, options = {}) =>
      instance.get(url, { params, ...options }).then(apiDataCallback),
    post: (url, data, params = emptyObj, options = {}) =>
      instance.post(url, data, { params, ...options }).then(apiDataCallback),
    put: (url, data) => instance.put(url, data).then(apiDataCallback),
    deletes: (url, params) => instance.delete(url, { params }).then(apiDataCallback),
    patch: (url, data, params = emptyObj) =>
      instance.patch(url, data, { params }).then(apiDataCallback),
    putWithFile: (url, data, params) =>
      instance
        .put(url, data, { headers: { "Content-type": "multipart/form-data" }, params })
        .then(apiDataCallback),
    postWithFile: (url, data, params) =>
      instance
        .post(url, data, { headers: { "Content-type": "multipart/form-data" }, params })
        .then(apiDataCallback),
    getFile: (url, params = emptyObj, options) =>
      instance
        .get(url, { params: { ...params, skipFormat: true }, ...options, responseType: "blob" })
        .then(apiDataCallback),

    addHeader: (key, value) => {
      instance.defaults.headers.common[key] = value;
    },
    removeHeader: (key) => {
      delete instance.defaults.headers.common[key];
    },
    _instance: instance,
  };
};

export { getInstance };
